/*
########    #######   ##     ##       ########   ########      ###     ########   ##    ##   
##     ##  ##     ##  ###   ###       ##     ##  ##           ## ##    ##     ##   ##  ##    
##     ##  ##     ##  #### ####       ##     ##  ##          ##   ##   ##     ##    ####     
##     ##  ##     ##  ## ### ##       ########   ######     ##     ##  ##     ##     ##      
##     ##  ##     ##  ##     ##       ##   ##    ##         #########  ##     ##     ##      
##     ##  ##     ##  ##     ##       ##    ##   ##         ##     ##  ##     ##     ##      
########    #######   ##     ##       ##     ##  ########   ##     ##  ########      ##      
*/

/**
 * jQuery stuff
 */
$(document).ready(function() {

	FastClick.attach(document.body);

	/**
	 * Test si les Media Queries sont supportées
	 * Ajoute la classe 'mq' au tag HTML si c'est le cas
	 */
	if ( Modernizr.mq('only all') ) {
		jQuery('html').addClass('mq');
	} else {
		jQuery('html').addClass('no-mq');
	}

	/**
	 * Browser detect : masquage de la bannière
	 */
	$('.browserdetect__close').click(function(e) {
		e.preventDefault();
		$('.browserdetect').addClass('browserdetect--hidden');
	});

	/**
	 * Toggle menu
	 */
	$(".nav-toggle").click(function(e){
		e.preventDefault();
		$(".navigation").toggleClass("open");
		$(".lines-button").toggleClass("close");
	});

	// $('.nav-main').lavalamp();

	/**
	 * Scroll to content home page
	 */
	$(".go-down").click(function(e){
		e.preventDefault();
		$("body,html").animate({scrollTop: $('.content').offset().top}, 800);
	});   

	/**
	 * Harmonize block new detail
	 */
	$(".row--harmonize").gridHarmonizer({
		selector:".harmonize",
		breakpoint:768,
		imageLoaded: true
	});

	/**
	 * Background color depend photo main color
	 */
	$.adaptiveBackground.run();

	/*
	 * Timeline
	 */
	var $timeline_block = $('.cd-timeline-block');

	//hide timeline blocks which are outside the viewport
	$timeline_block.each(function(){
		if($(this).offset().top > $(window).scrollTop()+$(window).height()*1) {
			console.log('hidden');
			$(this).find('.cd-timeline-year, .cd-timeline-content').addClass('is-hidden');
		}
	});

	//on scolling, show/animate timeline blocks when enter the viewport
	$(window).on('scroll', function(){
		$timeline_block.each(function(){
			if( $(this).offset().top <= $(window).scrollTop()+$(window).height()*1 && $(this).find('.cd-timeline-year').hasClass('is-hidden') ) {
				$(this).find('.cd-timeline-year, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
			}
		});
	});

	/*
	 * FORM
	 */
	if( $("body").hasClass('contact') ){
		$("#FContact").validationEngine({
			scroll: false,
			binded: false,
			promptPosition: 'topRight:-71,0',
			addFailureCssClassToField: 'inputError',
			autoPositionUpdate: true,
			maxErrorsPerField: 1
		});

		$("#FContact").submit(function(){
			if($("#FContact").validationEngine('validate')){
				button = $(this).find('.progress-bar').addClass('progress');
				var data = $(this).serialize() + '&act=envoi';
				// var div  = $(this).empty().html('<div class="form-return sending">envoi en cours...</div>');
				$.ajax({
					type    : "POST",
					data    : data,
					url     : "/contact/",
					dataType : 'json',
					success : function(retour) {
						switch(retour[0]){
							case 0:
								button.addClass('error');
								$(document).oneTime(2000, function(){
									button.removeClass('progress error');
								});
								break;
							case 1:
								button.addClass('success');
								$(document).oneTime(2000, function(){
									button.removeClass('progress success');
								});
								break;
						}
					}
				});
			}
			return false;
		});
	}

	/*
	 ######       ###     ##         ########   ########   ####  ########   
	##    ##     ## ##    ##         ##         ##     ##   ##   ##         
	##          ##   ##   ##         ##         ##     ##   ##   ##         
	##   ####  ##     ##  ##         ######     ########    ##   ######     
	##    ##   #########  ##         ##         ##   ##     ##   ##         
	##    ##   ##     ##  ##         ##         ##    ##    ##   ##         
	 ######    ##     ##  ########   ########   ##     ##  ####  ########   
	*/
	var $grid = $('.grid').isotope({
		itemSelector: '.grid-item',
		percentPosition: true
	});

	$grid.imagesLoaded().progress( function() {
		$grid.isotope('layout');
	}); 

	$(".grid--gallery").lightGallery({
		subHtmlSelectorRelative: true,
		addClass: 'customGallery',
		download: false
	}); 

});